// angular
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective } from "ngx-bootstrap/modal";

// services
import { AuthService } from '../core/auth.service';
import { AppService } from '../app.service';
import { SelfEvaluationService } from './self-evaluation.service';
import { TranslateService } from '@ngx-translate/core';
import { SelfEvaluationConfirmModalComponent } from './shared/self-evaluation-confirm-modal/self-evaluation-confirm-modal.component';
import { DOCUMENT } from "@angular/common";
import { Subscription } from 'rxjs';
import { DialogComponent } from '../dialog/dialog.component';
import { AccordionComponent } from 'ngx-bootstrap/accordion';
import { CoreService } from '../core/core.service';
import * as _ from 'lodash';
// others
declare var window: any;
declare var require;
declare var FRUBIL;


@Component({
    selector: 'self-evaluation-component',
    templateUrl: './self-evaluation.component.html',
    styleUrls: ['./self-evaluation.component.scss']
})
export class SelfEvaluationComponent implements OnInit, OnDestroy {

    token: any;
    sub: any;
    step = 0;
    isAcute = 1;
    have_sub_feeling_selection = false;
    questionnaireId: number;
    isStudy = true;
    itemPerPage: number;
    MINUMUM_ITEMS: number;
    feelingItemHeight = 100;
    rated = 0;
    internetExplorer = 0;
    haveHarming = false;
    isFinishSR = false;
    echo: any;

    // Layer : have_sub_feeling_selection => Layer = 3 || Layer = 2
    layer = 2;

    get isLoading() {
        return this.appService.isLoading;
    }

    set isLoading(isLoading) {
        this.appService.isLoading = isLoading;
    }

    classIcon = {};

    haveAnanmesticStep = true;

    researchAgreement = '';
    isAgree = 0;
    haveReadReasearchPolicies = false;
    contentForScientificAgree = [];
    textHTML = '';
    researchAgreementTitle = '';
    languages = [{
        id: 1,
        locale: "de_CH",
        code: "DE"
    }, {
        id: 4,
        locale: "en_GB",
        code: "EN"
    }];
    activeLanguage: any;
    headerTitle = null;
    deviceInnerHeight: number;
    contentHeight: number;
    btnHeight: number;
    error: '';
    deviceInfor;
    subscription: Subscription;
    harmingTemplate;

    type = this.selfEvaluationService.pageTypes.se.type;
    pageTitle: any = this.selfEvaluationService.pageTitle;
    contentHeader: any = this.selfEvaluationService.contentHeaderNormal;
    contentBody: any = this.selfEvaluationService.contentBodyNormal;
    contentHeaderFeedback: any = this.selfEvaluationService.contentHeaderFeedback;
    contentBodyFeedback = this.selfEvaluationService.contentBodyFeedback;
    agreementAccordion = this.selfEvaluationService.agreementAccordion;
    successfulUrl = null;
    isB2CSR = false;
    isMePatient = false;
    isAdditionalStep = false;
    haveAmnesticFeelingPage = false;
    haveCircumstance = false;
    activePage: number;
    totalPage: number;

    @ViewChild('confirmModal', {static: false}) confirmModal: SelfEvaluationConfirmModalComponent;
    @ViewChild('modalScientificInfor', {static: false}) modalScientificInfor: ModalDirective;
    @ViewChild('patientComment', {static: false}) patientComment;
    @ViewChild('dialog', { static: false }) dialog: DialogComponent;

    constructor(
        public elementRef: ElementRef,
        public router: Router,
        public route: ActivatedRoute,
        public authService: AuthService,
        public appService: AppService,
        public coreService: CoreService,
        public selfEvaluationService: SelfEvaluationService,
        public translate: TranslateService,
        @Inject(DOCUMENT) public document: Document,
        @Inject('konektoDomain') public konektoDomain : string,
    ) {
        this.itemPerPage = this.selfEvaluationService.itemPerPage;
        this.MINUMUM_ITEMS = this.selfEvaluationService.MINUMUM_ITEMS;
    }

    ngOnInit() {

        if (this.authService.isLoggedIn ) {
            if (!this.authService.isPatient) {
                this.authService.logout();
            }
        }

        this.type = this.coreService.activatedRouteSnapshot['data']['page'] || this.type;
        this.appService.SEType = this.type;
        this.appService.isSE = true;
        this.appService.isMePage = false;
        this.contentHeader = this.selfEvaluationService.pageTypes[this.appService.SEType].contentHeader;
        this.contentBody = this.selfEvaluationService.pageTypes[this.appService.SEType].contentBody;

        let ua = window.navigator.userAgent;
        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            this.internetExplorer = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            this.internetExplorer = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        if (localStorage.getItem('languages')) {
            this.languages = JSON.parse(localStorage.getItem('languages'));
        }

        if (localStorage.getItem('language') && !this.appService?.activeLanguage?.locale) {
            this.appService.activeLanguage = _.find(this.languages, { locale: localStorage.getItem('language')});
            return document.location.reload();
        }

        this.sub = this.route.params.subscribe(params => {
            this.token = params['token'];
            this.appService.isLoading = true;
            let isMobile = this.appService.isMobile ? 1 : 0;
            this.selfEvaluationService.enterSelfEvaluation(this.token, this.isAcute , this.itemPerPage, 1 ).subscribe(
                response => {
                    if (response['inactive']) {
                        this.appService.isLoading = false;
                        this.showInactiveQuestionnairePage();
                        return;
                    }
                    localStorage.setItem('clinic', JSON.stringify(response['clinic']));
                    this.appService.SEData = response;
                    this.step = response['step'];
                    if(response['viewed_item'] && response['total_item'] && response['viewed_item'] <= response['total_item']){
                        this.activePage = Math.floor(response['viewed_item']/this.itemPerPage);
                        this.totalPage = Math.floor(response['total_item']/this.itemPerPage);
                    }
                    this.selfEvaluationService.haveAnanmesticStep = response['is_have_ananmestic_step'] === 0 ? false : true;
                    if (isMobile) {
                        this.deviceInnerHeight = this.appService.deviceInnerHeight;
                        this.scrollToTop();
                        this.btnHeight = this.elementRef.nativeElement.querySelector('.wrapper__btns').offsetHeight;
                        this.contentHeight = this.deviceInnerHeight - this.btnHeight;
                        this.waitElementLoaded();
                    }

                    this.questionnaireId = response['patient_questionnaire_id'];
                    if(this.step === this.selfEvaluationService.pageTypes[this.type]['steps']['ADDITIONAL_STEP']
                        && response['is_finish_first_repeated_step']
                        && response['is_finish_first_repeated_step'] > 0){
                        this.isAdditionalStep = true;
                    }
                    this.classIcon = {
                        'wrapper__introduction__icon--feeling-selection life-circumstance': this.step === this.appService.steps.FEELING_SMOKE_DETECTOR,
                        'wrapper__introduction__icon--feeling-selection': this.step === this.appService.steps.FEELING_SELECTION,
                        'wrapper__introduction__icon--feeling-rating': this.step === this.appService.steps.FEELING_RATING,
                        'wrapper__introduction__icon--amnestic-phase': this.step === this.appService.steps.ANAMESTIC_SELECTION,
                        'wrapper__introduction__icon--completed': this.step === this.appService.steps.FINAL
                    };
                    if(this.appService.SEType === this.selfEvaluationService.pageTypes.repeatedSE.type){
                        this.classIcon = {
                            'wrapper__introduction__icon--feeling-selection': this.step === this.appService.repeatSteps.SELECTED_SMOKE_DETECTOR || this.step === this.appService.repeatSteps.NOT_SELECTED_SMOKE_DETECTOR,
                            'wrapper__introduction__icon--feeling-rating': this.step === this.appService.repeatSteps.FEELING_SELECTION,
                            'wrapper__introduction__icon--amnestic-phase': this.step === this.appService.repeatSteps.FEELING_RATING,
                            'wrapper__introduction__icon--completed': this.step === this.appService.repeatSteps.ANAMESTIC_SELECTION
                        };
                    }
                    this.isStudy = response['is_study'];
                    if (this.isStudy) {
                        this.contentBody = this.selfEvaluationService.contentBodyStudy;
                        this.contentHeader = this.selfEvaluationService.contentHeaderStudy;
                        if (this.step === this.selfEvaluationService.pageTypes[this.type]['showFeedbackStep'] && this.selfEvaluationService.isRedirectedFromAmnestic == true) {
                            this.selfEvaluationService.showFeedback = true;
                            this.selfEvaluationService.isRedirectedFromAmnestic = false;
                        }
                    }

                    this.appService.isLoading = false;
                    this.haveAmnesticFeelingPage = response['next_anamestic_page'];
                    this.isB2CSR = response['is_b2c'];
                    this.isMePatient = response['is_me'];

                    if(this.step === this.selfEvaluationService.pageTypes[this.type]['steps']['FEELING_SMOKE_DETECTOR'] && response['custom_layer'] <= response['max_custom_layer']){
                        this.haveCircumstance = true;
                        return this.beginQuestionnaires();
                    }
                    if (response['have_sub_feeling_selection'] && response['have_sub_feeling_selection'] === 1) {
                        this.have_sub_feeling_selection = true;
                        this.layer = 3;
                        // Redirect to Sub page if have SE Step stored
                        if (this.appService.SEStep.value === this.selfEvaluationService.pageTypes[this.type]['steps']['FEELING_SELECTION']
                            && this.step === this.selfEvaluationService.pageTypes[this.type]['steps']['FEELING_SELECTION']) {
                            return this.beginQuestionnaires();
                        }
                    }
                    this.appService.setCurrentSeStep(this.step);
                    this.successfulUrl = response['successful_url'];
                    if (this.successfulUrl) {
                        this.selfEvaluationService.isRedirectedFromAmnestic = false;
                        this.selfEvaluationService.showFeedback = false;
                    }
                    if (this.step === this.selfEvaluationService.pageTypes[this.type]['showFeedbackStep'] && !this.selfEvaluationService.isRedirectedFromAmnestic && !this.selfEvaluationService.showFeedback) {
                        this.setFinishSR();
                    }
                    this.getHeaderTitle();

                    this.selfEvaluationService.getItems(`patient-questionnaire/research-agreement-template/${this.appService.activeLanguage.id}`)
                        .subscribe(res => {
                            this.researchAgreement = res['template'].content;
                            this.researchAgreementTitle = res['template'].title;
                        });

                    this.haveHarming = response['have_harming'];
                    if (this.haveHarming) {
                        const clinic_id = JSON.parse(localStorage.getItem('clinic')).id;
                        this.selfEvaluationService.getItems(`patient-questionnaire/harming-template/${clinic_id}/${this.appService.activeLanguage.id}`)
                            .subscribe(res => {
                                this.harmingTemplate = res['data'];
                            });
                    }

                    if(response['language'] && response['language']['locale'] !== localStorage.getItem('language')){
                        // Set language to Local Storage and wait for applying on Self-evaluation-menu.component.ts
                        this.appService.activeLanguage = response['language'];
                        let defaultSystemLanguage;
                        let _self = this;
                        _self.isLoading = true;
                        setTimeout(function () {
                            if (_.find(_self.languages, {locale: _self.appService.activeLanguage['locale']})) {
                                defaultSystemLanguage = _self.appService.activeLanguage;
                            } else {
                                defaultSystemLanguage = _self.appService.getCurrentSystemLanguage();
                            }
                            localStorage.setItem('language', defaultSystemLanguage.locale);
                            localStorage.removeItem('defaultLanguage');
                            _self.getHeaderTitle();
                            _self.isLoading = false;
                            _self.translate.use(defaultSystemLanguage.locale);
                        }, 1000)
                    }

                    //init sr socket
                    this.listenPatientChange(response['patient_questionnaire_id']);
                },
                error => {
                    this.isLoading = false;
                    localStorage.removeItem('clinic');
                });
        });

        this.updateContentForScientificAgreement();
        this.subscription = this.translate.onLangChange.subscribe((event: any) => {
            this.updateContentForScientificAgreement();
            let language_id = this.languages[0]['id'];
            if(this.languages.find(item => item.locale == event.lang)){
                language_id = this.languages.find(item => item.locale == event.lang).id;
            }
            if (this.selfEvaluationService.isRedirectedFromAmnestic) {
                this.selfEvaluationService.getItems(`patient-questionnaire/research-agreement-template/${language_id}`)
                    .subscribe(res => {
                        this.researchAgreement = res['template'].content;
                        this.researchAgreementTitle = res['template'].title;
                    });
            }

            // 1490
            if (this.haveHarming) {
                let clinic_id = JSON.parse(localStorage.getItem('clinic')).id;
                this.selfEvaluationService.getItems(`patient-questionnaire/harming-template/${clinic_id}/${language_id}`)
                    .subscribe(res => {
                        this.harmingTemplate = res['data'];
                    });
            }

            // 1464
            const data = {
                'questionnaire_id': this.questionnaireId,
                'language': event.lang
            };
            this.isLoading = true;
            this.selfEvaluationService.changeLanguage(data).subscribe(value => {
                this.isLoading = false;
                localStorage.removeItem('defaultLanguage');
            });
        });

    }

    async waitElementLoaded() {
        while (!document.querySelector(".btn-next")) {
            await new Promise(r => setTimeout(r, 1000));
        }
    }

    scrollToTop() {
        const scrollStep = -window.scrollY / (500 / 15),
            scrollInterval = setInterval(function () {
                if (window.scrollY != 0) {
                    window.scrollBy(0, scrollStep);
                }
                else clearInterval(scrollInterval);
            }, 15);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        document.getElementById("top-el").scrollIntoView();
        setTimeout(function () {
            this.deviceInnerHeight = window.innerHeight;
        }, 200);
    }

    beginQuestionnaires() {
        const part = this.haveAmnesticFeelingPage ?  2 : 1;
        let _self = this;
        _self.headerTitle = null;
        switch (this.step) {
            case 0:
                this.updateStep();
                break;
            case 1:
                if(this.haveCircumstance){
                    return this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/' + this.step + '/' + 'circumstance']);
                }
                this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/' + this.step]);
                break;
            case 2:
                this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/2' + (this.have_sub_feeling_selection ? '/3' : '')]);
                break;
            case 3:
                // Repeat SR : Feeling Selection
                this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/2' + (this.have_sub_feeling_selection ? '/3' : '')]);
                break;
            case 4:
                // Normal SR : Anamnestic Selection
                this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/' + this.step + '/' + part]);
                break;
            case 5:
                this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/' + this.step]);
                break;
            default:
                this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token]);
        }
    }

    setHaveReadReasearchPolicies() {
        this.haveReadReasearchPolicies = !this.haveReadReasearchPolicies;
    }

    endResearchAgreement() {
        let data = {'questionnaire_id': this.questionnaireId, 'is_research_agreed': this.isAgree}
        this.selfEvaluationService.updateResearchAgreementAnswer(data).subscribe();
        this.selfEvaluationService.isRedirectedFromAmnestic = false;

        // In case b2c questionnaire -> Navigate back to konekto site
        if (this.isB2CSR) {
            this.selfEvaluationService.showFeedback = false;

            if (this.isMePatient) {
                setTimeout(() => {
                    const url = this.router.serializeUrl(this.router.createUrlTree(['/me/self-evaluation']));
                    window.open(url, '_blank');
                }, 500);
                return;
            }
            setTimeout(() => {
                window.open(this.konektoDomain + '/api/self-evaluation/' + this.token + '/success');
                this.router.navigate(['me/self-evaluation']);
            }, 500);
        } else {
            this.selfEvaluationService.showFeedback = true;
        }

        this.getHeaderTitle();
        return this.scrollToTop();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    openConfirm() {
        this.confirmModal.openConfirm();
    }

    hideModal() {
        this.confirmModal.hideModal();
    }

    continueLaterSubmit() {
        this.selfEvaluationService.countPauseSelfEvaluation({
            'questionnaire_id': this.questionnaireId
        }).subscribe(res => {
            this.router.navigate([this.selfEvaluationService.pageTypes[this.appService.SEType]['route'] + '/' + this.token + '/continue-later']);
        });
    }

    getMaximumnumber() {
        const deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        // device Width > 576 : Tablet
        if (deviceWidth > 576) {
            return this.itemPerPage;
        }
        let wrapperHeight = this.deviceInnerHeight > 0 ? this.deviceInnerHeight : this.elementRef.nativeElement.querySelector('.wrapper__selfevaluation').offsetHeight;
        let progressBarHeight = this.elementRef.nativeElement.querySelector('.se-progress-bar') ? this.elementRef.nativeElement.querySelector('.se-progress-bar').offsetHeight : 0;
        let headerTitleHeight = this.elementRef.nativeElement.querySelector('.header-title') ? this.elementRef.nativeElement.querySelector('.header-title').offsetHeight : 0;
        let actionBtnHeight = this.elementRef.nativeElement.querySelector('.wrapper__btns') ? this.elementRef.nativeElement.querySelector('.wrapper__btns').offsetHeight : 0;
        let itemPerScreen = (wrapperHeight - progressBarHeight - headerTitleHeight - actionBtnHeight) / this.feelingItemHeight;
        let itemPerPage = (Math.floor(itemPerScreen) * 2) - 1;
        return itemPerPage < this.MINUMUM_ITEMS ? this.MINUMUM_ITEMS : itemPerPage; // Remove 1 items for browser footer on Iphone
    }

    onpenScientificDialog() {
        this.modalScientificInfor.show();
    }

    updateContentForScientificAgreement() {
        this.translate.get('You have completed the entire questionnaire.').subscribe(value => {
            this.contentForScientificAgree = value.split('/');
        });
    }

    updateStep() {
        this.isLoading = true;
        this.selfEvaluationService.updateSelfEvaluationFirstStep(this.token, this.getCurrentDeviceInfor()).subscribe((res: any) => {
            if (res.success) {
                this.step = 1;
                this.appService.setCurrentSeStep(1);
                this.getHeaderTitle();
                this.isLoading = false;
                return this.scrollToTop();
            }
        });
    }

    sendFeedback() {
        let comment = this.patientComment.nativeElement.value;
        let data = {
            'questionnaire_id': this.questionnaireId,
            'rated': this.rated,
            'comment': comment
        };
        this.selfEvaluationService.sendSelfEvaluationPatientFeedback(data).subscribe((res: any) => {
            this.selfEvaluationService.showFeedback = false;
            this.selfEvaluationService.isRedirectedFromAmnestic = false;
            this.isFinishSR = true;
            this.getHeaderTitle();

            window.scrollTo(0, 0);
        });
    }

    setFinishSR() {
        this.appService.setCurrentSeStep(this.selfEvaluationService.pageTypes[this.type]['steps']['FINISH']);
        this.isFinishSR = true;
        // In case clinic define new successful url. Navigate to that url
        if (this.successfulUrl) {
            setTimeout(() => {
                window.open(this.successfulUrl);
            }, 500);
        }
    }

    setRated(rated) {
        this.rated = rated;
        setTimeout(() => {
            let wrapperHeight = this.elementRef.nativeElement.querySelector('.wrapper__selfevaluation').offsetHeight;
            window.scrollTo(0, wrapperHeight);
        }, 100)
    }

    getHeaderTitle() {
        let headerTitle = null;
        let _self = this;
        if (this.step == 0) {
            headerTitle = this.appService.SEType === this.selfEvaluationService.pageTypes.repeatedSE.type ? this.contentHeader[this.step] : this.pageTitle.overview;
        } else if (this.step === this.selfEvaluationService.pageTypes[this.appService.SEType]['showFeedbackStep']
            && this.selfEvaluationService.showFeedback) {
            headerTitle = this.pageTitle.thankyou;
        } else if (this.step === this.selfEvaluationService.pageTypes[this.appService.SEType]['showFeedbackStep']
            && !this.selfEvaluationService.isRedirectedFromAmnestic && !this.selfEvaluationService.showFeedback) {
            headerTitle = this.pageTitle.feedbackSent;
        } else if (this.step == -1) {
            headerTitle = this.pageTitle.linkDeactivated;
        }
    }

    getCurrentDeviceInfor() {
        let viewPoint = window.innerWidth + ' x ' + window.innerHeight;
        if (FRUBIL) {
            this.deviceInfor = JSON.stringify(FRUBIL) + ' ---- ' + window.navigator.userAgent + ' --- ' + window.navigator.platform;
            return {
                'system_used': FRUBIL.client.os_family,
                'system_version': FRUBIL.client.os,
                'browser_used': FRUBIL.client.name,
                'browser_version': FRUBIL.client.version,
                'device_used': FRUBIL.device.class,
                'model_name': FRUBIL.device.marketname,
                "view_port": viewPoint,
            }
        }
    }

    listenPatientChange(id) {
        this.echo = this.appService.initEcho();
        const self = this;
        this.echo.channel('Questionnaire.' + id).listen('InactivePatient', function (data) {
            self.showInactiveQuestionnairePage();
        });
    }

    showInactiveQuestionnairePage() {
        this.step = -1;
        this.appService.setCurrentSeStep(this.step);
        this.getHeaderTitle();
    }

    toggleAccordion(item){
        item['show'] = !item['show'];
    }
}
